<template>
  <div>
    <b-row>
      <h3 class="text-red">
        {{ this.$t("royalty_details") | capitalize }}
      </h3>
    </b-row>
    <b-row>
      <b-table
        id="stations"
        :items="data"
        :fields="fields"
        striped
        fixed
      >
        <template v-slot:cell(thresholdReached)="row">
          <boolean-status :is-true="row.item.aboveThreshold" />
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>

import { BooleanStatus } from "@/components"
import { bTableAlignmentMixin } from "@/utils/mixins"
import { capitalize } from "lodash"

export default {
  name: "StationGeneralDetails",
  mixins: [bTableAlignmentMixin],
  components: {
    BooleanStatus,
  },
  props: {
    data: Array,
  },
  computed: {
    fields () {
      return this.applyTableAlignment([
        {
          key: "year",
          label: capitalize(this.$t("year")),
        },
        {
          key: "province",
          label: capitalize(this.$t("province")),
        },
        {
          key: "provinceStationCount",
          label: capitalize(this.$t("province_station_count")),
        },
        {
          key: "provincialPopulation",
          label: capitalize(this.$t("provincial_population")),
        },
        {
          key: "royaltiesPaid",
          label: capitalize(this.$t("royalties_paid")),
        },
        {
          key: "revenue",
          label: capitalize(this.$t("revenue")),
        },
        {
          key: "thresholdReached",
          label: capitalize(this.$t("threshold_reached")),
        },
      ])
    },
  },
}
</script>
